import React from "react";
import "../../assets/css/BannerAlert.css";

const NotificationBanner = ({ text, url, type }) => {
  return (
    <div className="notification-banner">
      {/* <span className="notification-banner__text">{text}</span> */}
      <span className="notification-banner__text">
        {type !== "walkthrough" ? {text} : "Not sure where to start? Watch our"} {" "}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          walkthrough video
        </a>
      </span>
    </div>
  );
};

export default NotificationBanner;
